<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>施工管理</el-breadcrumb-item>
                <el-breadcrumb-item>安全帽定位</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="width:100%;height:100%;background:#fff;">
                <el-tab-pane label="安全帽定位" name="first">
                    <baidu-map class="map-box" :center="center" :zoom="12" @ready="handler" @click="getClickInfo">
                        <bm-marker v-for="(item,index) in points" @click="clickHandler(item)" :key="index" :position="item.position" :rotation='item.angle' :icon="{url: require('../../../assets/image/location.png'), size: {width: 25, height: 27}}">
                        </bm-marker>
                    </baidu-map>
                </el-tab-pane>
                <el-tab-pane label="配置管理" name="second">
                    <div class="build-bar">
                        <span>设备名称：</span>
                        <el-input placeholder="请输入设备名称" v-model="search.sn"></el-input>
                        <el-select
                        v-model="search.status"
                        clearable
                        filterable
                        placeholder="请选择状态"
                        class="select"
                        @change="search"
                        style="width:200px;margin-left:20px"
                        >
                        <el-option  v-for="item in stutasAll" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                        <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>                    
                        <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
                    </div>
                    <div class="main-table">
                        <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                            <template slot="empty">
                                <p>{{dataText}}</p>
                            </template>
                            <el-table-column label="序号" type="index" width="100"></el-table-column>
                            <el-table-column label="设备号">
                                <template slot-scope="scope">
                                    <span class="color5" >{{scope.row.sn}}</span>
                                </template> 
                            </el-table-column>
                            <el-table-column label="在线时间">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.updateDate }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="使用人员">
                                <template slot-scope="scope">
                                    <span>{{ scope.row.personName }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="GPS">
                                <template slot-scope="scope">
                                    <i v-if="scope.row.personId && ''!=scope.row.personId" class="el-icon-map-location" @click="ShowMap(scope.row)" style="color:#409EFF;cursor: pointer;font-size:30px;"></i>
                                    <i v-else class="el-icon-map-location" style="color:#909399;font-size:30px;"></i>
                                </template>
                            </el-table-column>
                            <el-table-column label="类型">
                                <template slot-scope="scope">
                                    <img src="../../../assets/image/vf.png" @click="video(scope.$index, scope.row)"  title="GPS+VF" style="width:40px;height:40px;cursor: pointer;" v-if="scope.row.type=='2'" />
                                    <img src="../../../assets/image/vf.png" @click="video1(scope.$index, scope.row)"  title="索金光" style="width:40px;height:40px;cursor: pointer;" v-else-if="scope.row.type=='3'" />
                                    <img src="../../../assets/image/unvf.png" @click="message"  title="GPS" style="width:40px;height:40px;cursor: pointer;" v-else />
                                </template>
                            </el-table-column>
                            <el-table-column label="设备二维码">
                                <template slot-scope="scope">
                                    <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" >
                                <template slot-scope="scope">
                                <!-- <el-button  size="mini" type="success">视频</el-button> -->
                                <el-button  size="mini" type="primary" @click="addRow(scope.$index, scope.row)">绑定</el-button>
                                <el-button  size="mini" v-if="isMenuExit('pro:elebox:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">解绑</el-button>                             
                                </template>
                            </el-table-column>
                        </el-table>
                        <!-- 表单列表 -->
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[5, 10, 20, 50]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalItems"
                        ></el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>

            
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
            :model="addForm"
            ref="addForm"
            label-width="100px"
            :label-position="labelPosition"
            :rules="rules"
            >
                <el-form-item label="人员:">
                   <el-select
                    v-model="personInfo"
                    clearable
                    filterable
                    placeholder="请选择状态"
                    class="select"
                    @change="searchperson"
                    style="width:300px;"
                   >
                   <el-option  v-for="item in person" :key="item.personId" :label="item.personName+'('+item.teamsName+' | '+item.phone+')'" :value="item.personId+','+item.teamsId"></el-option>
                 </el-select>  
                </el-form-item> 
 
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="addVis = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 二维码弹出框 -->
        <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import vueQr from 'vue-qr'
import base from '../../../untils/base'
export default {
    components: {
            vueQr
    },
    data(){
        return{
            tableSn:'',
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            addVis:false,
            dialogTitle:'',
            labelPosition:'right',
            addForm:{
             projectId:'',
             sn:'',
             personId:'',
             teamsId:''
            },
            uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
            uploadHead1: {
                accessToken: util.session.get('token')
            },
            rules:{
                sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
            icon:'',//配电箱图
            stutasAll:[{name:'已绑',value:'0'},{name:'未绑',value:'1'}],
            http:base.httpCtx,
            search:{
               projectId:'',
               personId:'',
               status:'',
               sn:''
            },
            person:[],
            personInfo:'',
            activeName:'first',
            map:undefined,
            center: {
                lng: 117.285033,
                lat: 31.86515
            },
            BMap:undefined,
            curIndex:undefined,//当前地图展示的gps
            points:[],//坐标集
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.search.projectId = this.groupId
        this.addForm.projectId = this.groupId
        this.getData()
    },
    methods:{
        getData(){
            var that = this
            this.search.pageSize = this.pageSize
            this.search.pageNum = this.currentPage
            myHttp.SnRelation(this.search).then(function(resp){
                if(resp.data.code=='200'){
                 // console.log(resp)
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                   
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.pageInfo.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },
       // 根据项目id获取人员
       // selectPersonInfoList
       getPerson(){
        var that =this
         myHttp.selectPersonInfoList({
            projectId:this.groupId
         }).then(function(resp){
                if(resp.data.code=='200'){
                 that.person =resp.data.data.list
                }else{
                   that.$message.error(resp.data.msg)
                }
            })
       },
        //添加
        addRow(index,row){
           this.getPerson()
            this.addVis = true
            this.addForm.id = ''
            this.addForm.sn = row.sn
            this.addForm.personId  = ''
            this.addForm.teamsId=''
            this.dialogTitle = '绑定'

        },
        //编辑
        handleEdit(index,row){
            this.addVis = true
            this.addForm.id = row.id
            this.addForm.sn = row.sn
            this.addForm.parameter = row.parameter
            this.addForm.location = row.location
            this.addForm.remarks = row.remarks
            this.addForm.photoUrl =row.photoUrl
            this.addForm.thumbnailUrl =row.thumbnailUrl
            this.dialogTitle = '修改',
             this.icon =row.thumbnailUrl && row.thumbnailUrl != '' ? base.httpCtx + row.thumbnailUrl: ''
        },
        //删除
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.updateGpsPerson({
                    id: row.relationId,
                    // updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('解绑成功')
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        //提交
        sumbitAddRow(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    //console.log(that.addForm.id)
                    // if(that.addForm.id==''){
             
                        myHttp.createGpsPerson(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('绑定成功')
                                    that.addVis = false
                                    that.currentPage = 1
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    // }else{
                    //     that.addForm.updateBy = util.session.get('user').id
                    //     myHttp.modDistribution(that.addForm).then(
                    //         function(resp) {
                    //             if (resp.data.code == '200') {
                    //                 that.$message.success('修改成功')
                    //                 that.addVis = false
                    //                 that.getData()
                    //             } else {
                    //                 that.$message.error(resp.data.msg)
                    //             }
                    //         },
                    //         function() {}
                    //     )
                    // }
                }
            })
        },

        //展示二维码
        erCode(index,row){
            this.codeVis = true
            // this.codeUrl = '/pages/equipCheck/equipCheck?snId='+row.sn+'&projectId='+row.project_id
            // this.codeUrl=  row.sn+','+row.projectId+','+row.projectName
            var obj=  {
                type:1,
                sn:row.sn,
                projectId:row.projectId,
                projectName:row.projectName
            }
            this.codeUrl=JSON.stringify(obj)                        
            // console.log( this.codeUrl)
            this.codeTit = 'app绑定'
        },

        /**
         * 展示轨迹
         */
        ShowMap(row){
            this.$router.push({path:'/hatSign/'+row.personId+'/'+row.sn+'/'+row.personName})
        },

        /**
         * 判断是否展示
         */
        isMenuExit(row){
            // var flag = util.common.filterBtnMenu(row)
            // return flag
            return true
        },

        /**
         * 获取历史记录
         */
        history(index,row){
            this.$router.push({ path: '/eleBoxHistory/'+row.sn })
        },
        searchperson(e){
           console.log(e)
           this.addForm.personId =e.split(',')[0]
           this.addForm.teamsId =e.split(',')[1]
        },

        //tab切换方法
        handleClick(tab, event){
            
        },

        //获取项目所有的GPS
        getGpsList(){
            var that = this
            myHttp.selectMaxDateGpsRecord({
                projectId:this.groupId,
                teamsType:'3'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    console.log(resp)
                    var list = resp.data.data.gpsList||[]
                    var result = []
                    var viewPoints = []
                    for(var i=0;i<list.length;i++){
                        // list[i].index = that.getIndexByEnt(list[i].entId)
                        if(list[i].latitude&&list[i].latitude!=''&&list[i].longitude&&list[i].longitude!=''){
                            list[i].position = {lng: parseFloat(list[i].longitude), lat: parseFloat(list[i].latitude)}
                            result.push(list[i])
                            viewPoints.push(list[i].position)
                        }
                    }
                    that.points = result
                    // that.map.setViewport(viewPoints);
                }
            })
        },

        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.BMap = BMap
            this.map.enableScrollWheelZoom();
            map.addControl(new BMap.ScaleControl());
            this.getAttendArea()
            this.getGpsList()
        },
        //地图点击
        getClickInfo(e){
            if(!this.curIndex){
                var allOverlay = this.map.getOverlays();
                for(var i=0;i<allOverlay.length;i++){
                    if(allOverlay[i].toString()=="[object Overlay]"){
                        this.map.removeOverlay(allOverlay[i]);
                    }
                }
            }
            this.infoWindowClose()
        },

        //获取电子围栏
        getAttendArea(){
            var that = this;
            myHttp.getProjectById({
                id: this.groupId
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data.project;
                    that.showFenceArea(data.enclosure);
                    
                } else {
                    that.$message.error(resp.data.msg);
                }
            }, function (error) {
            });
        },
        //展示电子围栏
        showFenceArea(mapArea){
            if (mapArea != undefined && mapArea != ""){
                var viewPoints = []
                this.allPoint = JSON.parse(mapArea);
                for (var j = 0; j < this.allPoint.length; j++) {
                    this.currentPonit = this.allPoint[j];
                    var list = [];
                    for (var i = 0; i < this.currentPonit.length; i++) {
                        list.push(new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat));
                        var point = new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat);
                        // pointList.push(point);
                        var marker = new BMap.Marker(point);
                        var index = i + 1;
                        var label = new BMap.Label(index, {
                            offset: new BMap.Size(5, 4)
                        });
                        label.setStyle({
                            background: 'none', color: '#fff', border: 'none'//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                        });
                        marker.setLabel(label);//显示地理名称
                        //this.map.addOverlay(marker);
                        viewPoints.push({lng: parseFloat(this.currentPonit[i].lng), lat: parseFloat(this.currentPonit[i].lat)})
                    }
                    var polygonList = new BMap.Polygon(list, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    this.map.addOverlay(polygonList);
                }
                this.currentPonit = []
                this.map.setViewport(viewPoints);
            }
        },

        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        //点击定位人员
        clickHandler(e){
            this.curIndex = e
            this.showMapMarker(e)
        },
        //展示地图数据
        showMapMarker(obj){
            var _selt = this
            // 复杂的自定义覆盖物
            function ComplexCustomOverlay(point,obj){
                this._point = point;
                this._option = obj
            }
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map){
                this._map = map;
                var option = this._option;
                var div = this._div = document.createElement("div");
                div.style.position = "absolute";
                div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
                div.style.height = "130px";
                div.style.width = "180px";
                div.style.background = "rgba(19, 46, 140, 0.8)";
                div.style.borderRadius = "5px";
                div.style.padding = "10px";
                div.style.cursor = 'pointer'
                var that = this;

                //图片
                // var imgDiv = document.createElement("img");
                // imgDiv.style.position = "relative";
                // imgDiv.style.width = "180px";
                // imgDiv.style.height = "150px";
                // imgDiv.style.marginBottom = "10px";
                // var imgs = option.photoFile
                // var img = option.photoFile&&option.photoFile!=''?base.httpCtx+option.photoFile:''
                // if(img==''){
                //     imgDiv.src = require('../../assets/image/zanwutupian.png')
                // }else{
                //     imgDiv.src = img
                // }
                // div.appendChild(imgDiv);

                //姓名
                var nameText = document.createElement("p");
                nameText.style.position = "relative";
                nameText.style.width = "100%";
                nameText.style.height = "30px";
                nameText.style.fontSize = "12px";
                nameText.style.color = "rgba(255, 255, 255, 1)";
                nameText.style.whiteSpace = "nowrap";
                nameText.style.textOverflow = "ellipsis";
                nameText.style.overflow = "hidden";
                nameText.innerHTML = '姓名：' + option.personName||'';
                // nameText.title = option.personName||'';
                div.appendChild(nameText);

                // sn
                var progressText = document.createElement("p");
                progressText.style.position = "relative";
                progressText.style.width = "100%";
                progressText.style.height = "30px";
                progressText.style.fontSize = "12px";
                progressText.style.color = "rgba(255, 255, 255, 1)";
                progressText.innerHTML = '序列号：'+ option.sn||'';
                div.appendChild(progressText);

                //超速
                var addrText = document.createElement("p");
                addrText.style.position = "relative";
                addrText.style.width = "100%";
                addrText.style.height = "30px";
                addrText.style.fontSize = "12px";
                addrText.style.color = "rgba(255, 255, 255, 1)";
                addrText.style.whiteSpace = "nowrap";
                addrText.style.textOverflow = "ellipsis";
                addrText.style.overflow = "hidden";
                addrText.title = option.address||'';
                // var result = '无'
                // if(option.warnField=='2'){
                //     result = '超速'
                // }
                // else{
                //     result = option.speed&&option.speed!=''?option.speed:0
                // }
                addrText.innerHTML = '时间：'+option.updateDate||'';
                div.appendChild(addrText);

                //跳转
                // var trap = document.createElement('a');
                // trap.style.position = "relative";
                // trap.style.width = "100%";
                // trap.style.height = "30px";
                // trap.style.fontSize = "12px";
                // trap.style.lineHeight = '2vh';
                // trap.style.color = "rgba(255, 255, 255, 1)";
                // trap.href = '/trailOne/'+option.id
                // trap.innerHTML = '轨迹查看'
                // div.appendChild(trap);

                div.onclick = function(){}

                map.getPanes().labelPane.appendChild(div);
                
                return div;
            }
            ComplexCustomOverlay.prototype.draw = function(){
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                // console.log(pixel)
                this._div.style.left = (pixel.x + 20) + 'px' ;
                this._div.style.top  = pixel.y  + 'px' ;
            }
            var allOverlay = this.map.getOverlays();
            for(var i=0;i<allOverlay.length;i++){
                if(allOverlay[i].toString()=="[object Overlay]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
            var gpsLi = obj.position;
            var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi.lng, gpsLi.lat),obj);
            this.map.addOverlay(myCompOverlay);
        },
        // 跳转视频
        video(index,row){
             window.open('http://112.54.97.178:81/previewflash.aspx?devCode='+row.sn+'&user=tskj&pwd=12345&lineId=1&autoPlay=1')
            // this.$router.push({path:'/vf/'+row.sn})
        },
        //跳转索金光
        video1(index,row){
            // console.log(row)
            this.$router.push({path:'/vf/'+row.sn})
        },
        message(){
            this.$message.error('暂无')
        }
    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
    .avatar{
        width: 100%;
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
        
    }
</style>

<style>
    @import '../../../assets/css/common.css';
    .box-second .el-tabs__content{
        height: calc( 100% - 6vh );
    }
    .box-second .el-tab-pane{
        height: 100%;
    }
</style>